import { FC } from 'react';
import { css } from '@bts-web/utils-style-engine';
import { TwoFaSectionTitle } from '../TwoFaSectionTitle';
import { TwoFaSectionDescription } from '../TwoFaSectionDescription';
import { TwoFaCodeSubmitBox } from '../TwoFaCodeSubmitBox/TwoFaCodeSubmitBox';
import { TTwoFaCommonProps } from '../../SetupTwoFaModal/types';
import { TwoFaCodeSetupActionVariant } from '../../../../../../auth';
import { TwoFaScreenTranslations } from '../../ResetTwoFaModal/utils/get2faTranslations';

const InputCodePage: FC<
  Pick<TTwoFaCommonProps, 'onContinue' | 'bindRecoveryCodes'> & {
    actionVariant: TwoFaCodeSetupActionVariant;
    translations: TwoFaScreenTranslations;
  }
> = ({ onContinue, bindRecoveryCodes, actionVariant, translations }) => {
  return (
    <>
      <div
        className={css({
          display: 'flex',
          flex: '1',
          flexDirection: 'column',
          justifyContent: 'center',
          pt: { base: 'extra_large_5', md: 'extra_large' },
        })}
      >
        <TwoFaSectionTitle title={translations.corpOnboardingEmailQTitle} />
        <TwoFaSectionDescription
          textContent={translations.authenticationText}
        />

        <TwoFaCodeSubmitBox
          bindRecoveryCodes={bindRecoveryCodes}
          onContinue={onContinue}
          actionVariant={actionVariant}
        />
      </div>
    </>
  );
};

export { InputCodePage };
